import { render, staticRenderFns } from "./ApportionmentDetailsModal.vue?vue&type=template&id=1a2d1fa8"
import script from "./ApportionmentDetailsModal.vue?vue&type=script&lang=js"
export * from "./ApportionmentDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./ApportionmentDetailsModal.vue?vue&type=style&index=0&id=1a2d1fa8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports